/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1641
 */

require(/* 86 */"../1650/86/index")({
  target: "Math",
  stat: true
}, {
  log1p: require(/* 1259 */"./1259")
})
